class ApplicationError extends Error {
	name = "ApplicationError";

	static defaultMessage = {
		400: "Bad Request",
		401: "Not Authorized",
		403: "Not Permitted",
		404: "Not Found",
		500: "Internal Error",
		503: "Service Unavailable",
	};

	static of = error =>
		error instanceof ApplicationError
			? error
			: new ApplicationError(error, error.code || 500, error.message);

	static BadRequest = () => new ApplicationError(null, 400);

	static NotAuthorized = () => new ApplicationError(null, 401);

	static NotFound = () => new ApplicationError(null, 404);

	static ServiceUnavailable = () => new ApplicationError(null, 503);

	constructor(
		originalError,
		code = 500,
		message = ApplicationError.defaultMessage[code],
		tags = null,
	) {
		super(message);
		this.code = code;
		this.originalError = originalError;
		this.stack = originalError?.stack || new Error().stack;
		this.tags = tags;
	}

	toSerializable() {
		const { name, message, code, stack, originalError, tags } = this;
		return {
			name,
			message,
			code,
			stack: typeof stack === "string" ? stack.split("\n") : stack,
			originalError: originalError
				? {
						name: originalError.name,
						code: originalError.code,
						message: originalError.message,
				  }
				: null,
			tags,
		};
	}

	toJSON() {
		return this.toSerializable();
	}
}

export default ApplicationError;
